import { useEffect, useState } from 'react';

const MatchitoCelebration = ({ show, message, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    if (show) {
      setIsVisible(true);
      setIsFading(false);
      const timer = setTimeout(() => {
        handleClose();
      }, 4500);
      return () => clearTimeout(timer);
    }
  }, [show]);

  const handleClose = () => {
    setIsFading(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsFading(false);
      if (onClose) onClose();
    }, 400);
  };

  if (!isVisible) return null;

  return (
    <div
      data-testid="matchito-celebration"
      className={`fixed inset-0 z-[9999] flex items-center justify-center transition-opacity duration-400 ${isFading ? 'opacity-0' : 'opacity-100'}`}
      onClick={handleClose}
      style={{ backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}
    >
      <div
        className={`flex flex-col items-center gap-4 transition-transform duration-400 ${isFading ? 'scale-90' : 'scale-100'}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative w-56 h-56 sm:w-72 sm:h-72">
          <img
            src="/matchito.gif"
            alt="Matchito celebrando"
            className="w-full h-full object-contain"
          />
        </div>
        {message && (
          <div className="bg-white dark:bg-zinc-800 rounded-xl shadow-2xl px-6 py-4 max-w-sm text-center animate-bounce-in">
            <p className="text-base sm:text-lg font-bold text-zinc-900 dark:text-zinc-100">{message}</p>
          </div>
        )}
        <button
          onClick={handleClose}
          className="text-white/70 hover:text-white text-sm mt-2 transition-colors"
          data-testid="matchito-close"
        >
          Cerrar
        </button>
      </div>

      <style>{`
        @keyframes bounceIn {
          0% { transform: scale(0.5); opacity: 0; }
          60% { transform: scale(1.05); opacity: 1; }
          100% { transform: scale(1); }
        }
        .animate-bounce-in {
          animation: bounceIn 0.5s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default MatchitoCelebration;
